import type { ValidationFunction } from "core/validators";
import HealthCentre from "parog-web/models/health-centre";
import MedicModel from "parog-web/models/medic";

export default function validateMedicHealthCentre(): ValidationFunction {
  return (key, newValue: any, oldValue, changes, content) => {
    const medic =
      !newValue || newValue instanceof MedicModel ? newValue : oldValue;
    if (!medic) return true;
    const HC =
      key == "referentMedic"
        ? changes?.healthCentreConfigurator instanceof HealthCentre
          ? changes.healthCentreConfigurator
          : content?.healthCentreConfigurator
        : changes?.healthCentreSupport instanceof HealthCentre
          ? changes.healthCentreSupport
          : content?.healthCentreSupport;

    return (
      (medic as unknown as MedicModel)?.healthCentres?.includes(
        HC as HealthCentre
      ) || `Le medic doit faire partie du centre ${(HC as HealthCentre)?.name}`
    );
  };
}
